import React from 'react';

import {
  Typography,
} from '@material-ui/core';


const activityTerms = (props) => {
  let text = null;
  if (props.type === 'interests' && props.item.activity_type === 'sent' && props.item.is_deletable) {
    text = (
      <Typography variant="body1">
        You have sent an interest to this candidate. If you have sent this by mistake,
         you can undo this action within 30 minutes of your sent time.
        <br />
        The contact details of this candidate will be unlocked only when they accept your interest.
      </Typography>
    );
  }
  if ((props.type === 'interests' || props.type === 'requests') && props.item.activity_type === 'sent' && props.item.reply && props.item.reply.reply === 'accept') {
    text = (
      <Typography variant="body1">
        You have access to full contact details of this candidate.
      </Typography>
    );
  }
  if (props.type === 'interests' && props.item.activity_type === 'received') {
    text = (
      <Typography variant="body1">
        You have access to full contact details of this candidate.
      </Typography>
    );
  }
  if (props.type === 'requests' && props.item.activity_type === 'sent' && props.item.is_deletable) {
    text = (
      <Typography variant="body1">
        You have sent a request to this candidate. If you have sent this by mistake,
         you can undo this action within 30 minutes of your sent time.
        <br />
        The contact details of this candidate will be unlocked only when they accept your request.
      </Typography>
    );
  }
  if (props.type === 'requests' && props.item.activity_type === 'received') {
    text = (
      <Typography variant="body1">
        You have access to full contact details of this candidate.
        Please send the requested items via those contact details.
      </Typography>
    );
  }

  return (
    <React.Fragment>
      {text}
    </React.Fragment>
  );
};

export default activityTerms;



// WEBPACK FOOTER //
// ./src/activities/components/ActivityTerms.js